import React, { useEffect } from 'react';

import qs from 'qs';
import Quiz from './Components/quiz.jsx';
import _ from 'lodash';

import styles from './App.module.scss';
import { Grid, Button, Header, Image } from 'semantic-ui-react';

import {
  BrowserRouter as Router,
  Link,
  Switch,
  Route,
  useLocation
} from "react-router-dom";

import Measure from 'react-measure';

import individualQuiz from './individual.json';
import managerQuiz from './manager.json';
import { useDispatch, useSelector } from 'react-redux';
import { identifyUser } from 'sagas';
import ContactService from 'services/contact.service';
import mixpanel from 'mixpanel-browser';


const appId  = '5ed154409db1725f766275df';

function App(props) {
  return (
    <Measure
      bounds
      onResize={contentRect => {
        if (window.parent) {
          window.parent.postMessage({
            action: 'QUIZ_HEIGHT_CHANGED',
            payload: contentRect.bounds.height
          }, '*');
        }
      }}
    >
      {({ measureRef }) => (
        <div ref={measureRef} className={styles.app}>
          <Router basename="/quiz">
            <Switch>
              <Route path="/" exact>
                <QuizChooser />
              </Route>
              <Route path="/manager" exact>
                <Quiz quiz={managerQuiz} />
              </Route>
              <Route path="/individual" exact>
                <Quiz quiz={individualQuiz} />
              </Route>
            </Switch>
          </Router>
        </div>
      )}
    </Measure>
  );
}

function QuizChooser() {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const email = useSelector(state => {
    return _.get(state, "application.contact.email");
  })


  useEffect(() => {
    window.parent.postMessage({
      action: 'QUIZ_APPLICATION_LOADED'
    }, '*');

    window.addEventListener('message', function(e) {
      const data = e.data;
      if(data && data.action === 'QUIZ_APPLICATION_TOKEN'){
        const token = data.payload;
        if(token){
          ContactService.saveToken(appId, token);
          dispatch(identifyUser(appId));
        }
      }
    });

    dispatch(identifyUser(appId));
  }, []);

  useEffect(() => {
    if(email){
      mixpanel.identify(email);
      mixpanel.people.set({
        "$email": email
      });
    }

  }, [email])

  return (
    <Grid verticalAlign='middle' className={styles.quizChooser} stretched>
      <Grid.Row>
        <Grid.Column mobile={16} tablet={11} computer={11} textAlign='center'>
          <Grid container>
            <Grid.Column width={1} only='tablet computer' textAlign='center' verticalAlign='middle'>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={14} computer={14}>
              <div className={styles.quizChooserInner}>
                <Header as='h1'>
                  Is your sales culture primed for success?

                  <Header.Subheader >
                    Take this 30-second quiz to get your personalized report.
                  </Header.Subheader>
                </Header>
                <div className={styles.choices}>
                  <div>
                    <Link to='/manager'>
                      <Button size='big' color='black'>I lead a team of salespeople</Button>
                    </Link>
                  </div>
                  <div>
                    <Link to='/individual'>
                      <Button size='big' color='black'>I am a sales rep</Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={5} computer={5} textAlign='center' stretched>
          <Image src="/images/poster.jpg" />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default App;